
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 72 72\" id=\"success\" ><title>&#x6210;&#x529F;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M19 34.54l11.545 11.923L52.815 24\"/></g></symbol>";
module.exports = sprite.add(image, "success");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/toast/style/assets/success.svg
// module id = 503
// module chunks = 0 1